/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {getTSRoleValues, TSRole} from '../../models/enums/TSRole';

export default class RoleUtilService {

    static $inject = [];

    /* @ngInject */
    constructor() {
    }

    public getAllRolesButGesuchsteller(): Array<string> {
        return this.getAllRoles().filter(element =>
            element !== TSRole[TSRole.BETROFFENER]
        );
    }

    public getAllRolesButGesuchstellerArray(): Array<TSRole> {
        return this.removeRoles(getTSRoleValues(), [TSRole.BETROFFENER, TSRole.UNASSIGNED_ROLE]);
    }

    public getAllRolesButGesuchstellerAndKanton(): Array<TSRole> {
        return this.removeRoles(this.getAllRolesButGesuchstellerArray(), [TSRole.KANTON_VERWALTER, TSRole.KANTON_INSPEKTOR]);
    }

    public getAllRolesWithNAButGesuchstellerArray(): Array<TSRole> {
        return this.removeRole(getTSRoleValues(), TSRole.BETROFFENER);
    }

    public getRolesForSchadenfaelle(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole.ANLAUFSTELLE_SACHBEARBEITER,
            TSRole.ANLAUFSTELLE_SCHAETZER, TSRole.BETROFFENER, TSRole.KANTON_INSPEKTOR];
    }

    public getRolesForCockpit(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.FONDSSUISSE_SACHBEARBEITER];
    }

    public getAllRoles(): Array<string> {
        let result: Array<string> = [];
        for (let prop in TSRole) {
            if ((isNaN(parseInt(prop)))) {
                result.push(prop);
            }
        }
        return result;
    }

    public getSuperAdminRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN];
    }

    public getAdministratorRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN];
    }

    public getStatistikRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.KANTON_INSPEKTOR];
    }

    public getAnlaufstelleRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.ANLAUFSTELLE_SACHBEARBEITER];
    }

    public getAnlaufstelleRoleWithAdmins(): Array<TSRole> {
        return [TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN, TSRole.ANLAUFSTELLE_SACHBEARBEITER];
    }

    public getFondssuisseRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.FONDSSUISSE_SACHBEARBEITER];
    }

    public getGesuchstellerRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.BETROFFENER];
    }

    public getGesuchstellerOnlyRoles(): Array<TSRole> {
        return [TSRole.BETROFFENER];
    }

    public getAnlaufstelleVerwalterRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.ANLAUFSTELLE_VERWALTER];
    }

    public getVerwalterRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.ANLAUFSTELLE_VERWALTER, TSRole.KANTON_VERWALTER];
    }

    public getAnlaufstelleVerwalterOnlyRole(): Array<TSRole> {
        return [TSRole.ANLAUFSTELLE_VERWALTER];
    }

    public getAnlaufstelleSubuserRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole.ANLAUFSTELLE_SCHAETZER];
    }

    public getAnlaufstelleSubuserRolesOnly(): Array<TSRole> {
        return [TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole.ANLAUFSTELLE_SCHAETZER];
    }

    public getInspektoratVerwalterRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.KANTON_VERWALTER];
    }

    public getSchaetzerRolesOnly(): Array<TSRole> {
        return [TSRole.ANLAUFSTELLE_SCHAETZER];
    }

    public getAllowedToCreateSchadenfallRoles(): Array<TSRole> {
        return [TSRole.BETROFFENER, TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole.SUPER_ADMIN,
            TSRole.FONDSSUISSE_ADMIN, TSRole.FONDSSUISSE_SACHBEARBEITER]
    }

    public getAllowedToCreatePapierSchadenfallRoles(): Array<TSRole> {
        return [TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole.SUPER_ADMIN,
            TSRole.FONDSSUISSE_ADMIN, TSRole.FONDSSUISSE_SACHBEARBEITER]
    }

    public getAllowedToDeleteSchadenfallRoles(): Array<TSRole> {
        return [TSRole.SUPER_ADMIN, TSRole.FONDSSUISSE_ADMIN, TSRole.FONDSSUISSE_SACHBEARBEITER,
            TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole.KANTON_INSPEKTOR, TSRole.BETROFFENER];
    }

    public getRolesAllowedForAnlaufstellenPruefung(): Array<TSRole> {
        let allowedRoles: Array<TSRole> = [];
        allowedRoles = allowedRoles.concat(this.getAnlaufstelleRoles());
        allowedRoles = allowedRoles.concat(this.getAdministratorRoles());
        allowedRoles = allowedRoles.concat(this.getFondssuisseRoles());
        return allowedRoles;
    }

    public getRolesAllowedForSchaetzer(): Array<TSRole> {
        let allowedRoles: Array<TSRole> = [];
        allowedRoles = allowedRoles.concat(this.getAnlaufstelleRoles());
        allowedRoles = allowedRoles.concat(this.getAdministratorRoles());
        allowedRoles = allowedRoles.concat(this.getFondssuisseRoles());
        allowedRoles = allowedRoles.concat(this.getSchaetzerRolesOnly());
        return allowedRoles;
    }

    public removeRole(roles: Array<TSRole>, role: TSRole): Array<TSRole> {
        let index = roles.indexOf(role, 0);
        if (index > -1) {
            roles.splice(index, 1);
        }
        return roles;
    }

    public removeRoles(roles: Array<TSRole>, rolesToRemove: Array<TSRole>): Array<TSRole> {
        for (let role of rolesToRemove) {
            roles = this.removeRole(roles, role);
        }
        return roles;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/RoleUtilService.ts